import axios from '../../../config/axios.config';
import { AppModal } from '@app/components/AppModal';
import AppAlert from '@app/components/AppAlert';
import { Checkbox, FormLabel } from '@mui/joy';
import RequestField from '../components/RequestField';
import { useState } from 'react';
import { validateAndCreateParrainage } from '@app/api/data/potentiels-parrainages-modifie';
import AppLoading from '@app/components/AppLoading';

type props = {
    onSuccess: () => void;
    idToUpdate: number[];
    open: boolean;
    onClose: () => void;
};

export const ValidatePotentiels = ({
    idToUpdate,
    onSuccess,
    open,
    onClose,
}: props) => {
    // Liste Noire Affecté à
    const [loading, setLoading] = useState<boolean>(false);

    const submit = async () => {
        setLoading(true);
        await Promise.all(
            idToUpdate.map((id) => validateAndCreateParrainage(id.toString()))
        ).finally(() => {
            onSuccess();
            onClose();
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        });
    };

    return (
        <AppModal
            handleSubmit={submit}
            icon="CheckIcon"
            title={`Validation des potentiels parrainages`}
            submitText="Valider"
            submitIcon="CheckIcon"
            open={open}
            onClose={onClose}
        >
            <div className="flex min-w-[400px] flex-col">
                <label className="mb-4">
                    {idToUpdate.length} parraiange(s) à créer
                </label>
                {loading ? (
                    <AppLoading />
                ) : (
                    <AppAlert
                        message={{
                            color: 'warning',
                            title: 'Validation des potentiels parrainages',
                            text: 'Valider les potentiels parrainages sélectionnés ?',
                        }}
                    />
                )}
            </div>
        </AppModal>
    );
};
export default ValidatePotentiels;
